// Vendored from Tremor (tremor.so) Card, adapted to our theme tokens.
import type React from "react";

import { cn } from "@/lib/utils";

export function Card({ className, ...props }: React.ComponentProps<"div">): React.ReactElement {
  return (
    <div
      className={cn(
        "relative w-full rounded-lg border border-border bg-card p-6 text-card-foreground shadow-xs",
        className,
      )}
      data-slot="tremor-card"
      {...props}
    />
  );
}
